import {
  DEFAULT_DRILL,
  DEFAULT_FILTER_LIMIT,
  DEFAULT_FILTERS,
  DEFAULT_MODE,
  HARD_LIMIT,
  PATH_STRING_SEPARATOR,
} from './config';
import { WEEKDAYS } from './datetime';

const FILTER_COUNT = 1;
const DEFAULT_NAME = gettext('Фильтр');

export class Filter {

  constructor(name) {
    this.name = name || (DEFAULT_NAME + ' ' + FILTER_COUNT);
    this.drilldown = [defaultDimension];
  }

  /**
   * Set subview type
   * one of: explore, series, chart
   */
  setMode(mode) {
    if (this.mode !== mode) {
      this.changed();
    }
    this.mode = mode;
  }

  isPolitic() {
    return this.content_type !== 'filter';
  }

  isExplore() {
    return this.mode === 'explore';
  }

  isChart() {
    return this.mode === 'chart';
  }

  isChartArea() {
    return this.mode === 'chart-area';
  }

  isStat() {
    return this.mode === 'stat';
  }

  isReport() {
    return this.mode === 'report';
  }

  isReports() {
    return this.mode === 'reports';
  }

  isTree() {
    return this.mode === 'tree';
  }

  get isGraph() {
    return this.isReports() && this.url === '/analytics/report/graph/wizard/';
  }

  isAnomaly() {
    return this.isReports() && this.url === '/analytics/report/anomaly/';
  }

  get isCatalog() {
    return this.children.length && this.isExplore();
  }

  get isCard() {
    return this.isReports() && this.url === '/analytics/card/';
  }

  get isCardAccount() {
    return this.isCard && this.drilldown[0].startsWith('agent_account@');
  }

  get isDimensionCard() {
    return this.content_type === 'dimensioncardfilter';
  }

  get isViewFacts() {
    return this.isExplore() && (this.listType === 'table' ||
      this.listType === 'brief' || this.listType === 'thumblist') ||
      this.isReport();
  }

  get isViewStat() {
    return this.isStat() || this.isChartArea() || this.isChart() ||
      this.isGraph ||
      this.isTree();
  }

  get isViewReport() {
    return this.isReports() && !this.isGraph;
  }

  get hasQuery() {
    return this.query && this.query.rules && this.query.rules.length;
  }

  setList(mode) {
    this.setMode('explore');
    this.listType = mode;
  }

  toggleSkipStat() {
    this.skipStat = !this.skipStat;
  }

  /**
   * Add drilldown (X) dimension
   */
  addDrilldown(dimension) {
    if (!this.drilldown || !this.drilldown.length) {
      this.drilldown = [dimension];
    } else {
      this.drilldown.push(dimension);
    }
  }

  /**
   * Set drilldown (X) dimension
   */
  setDrilldown(dimension) {
//             console.log('Set drilldown', dimension);
    this.drilldown = [dimension];
    this.setOrder(dimension);
  }

  /**
   * Remove drilldown (X) dimension
   */
  removeDrilldown(name) {
    let ax;
    if ((ax = this.drilldown.indexOf(name)) !== -1) {
      this.drilldown.splice(ax, 1);
    }
    this.orderDim = this.order = null;
  }

  /* True if filters has drilldown */
  hasDrilldown(name) {
    return this.drilldown.indexOf(name) !== -1;
  }

  /* add child filter */
  addChild(filter) {
    this.removeChild(filter);
    this.children.push(filter);
  }

  /* Remove child filter */
  removeChild(filter) {
    this.children = (this.children || []).filter(e => e.id != filter.id);
  }

  find(predicate) {
    if (predicate(this)) {
      return this;
    }
    for (let i = 0; i < this.children.length; ++i) {
      let child = this.children[i];
      let f = child.find(predicate);
      if (f) {
        return f;
      }
    }
  }

  typize(path) {
    if (!path) {
      path = this.name;
    } else {
      path = path + ' | ' + this.name;
    }
    this.saved = true;
    this._changed = undefined;
    this.path = path;

    this.children = this.children.map(child => {
      child = Object.setPrototypeOf(child, Filter.prototype);
      child.typize(path);
      return child;
    });
  }

  getPathName() {
    return this.path || this.name;
  }

  isActive(drilldown_name) {
    let active = this.drilldown.indexOf(drilldown_name) >= 0;
    return active;
  }

  isParent(drilldown_name) {
    for (let index in this.drilldown) {
      let drill = this.drilldown[index];
      if (drill.split('@')[0] === drilldown_name.split('@')[0]) return true;
    }
    return false;
  }

  hasFilters() {
    return this.drilldown.length ||
      this.filters.length ||
      this.xaxis != null;
  }

  hasFilter(filter) {
    return this.filters.some(item =>
      item.dimension === filter.dimension && item.value === filter.value);
  }

  setOrder(dimension, attr) {
    this.orderDim = dimension;
    if (Filter.isTimeDimension(dimension)) {
      this.orderDir = 'desc';
      this.order = Filter.orderForTimeDimension(dimension);
    } else if (dimension === 'agent_time@hour:hour') {
      this.orderDir = 'asc';
      this.order = 'agent_time.hour';
    } else if (dimension === 'agent_time@weekday:weekday') {
      this.orderDir = 'asc';
      this.order = 'agent_time.weekday';
    } else {
      this.orderDir = 'desc';
      this.order = attr || 'record_count';
    }
    this.changed();
  }

  addKeyword(keyword) {
    this.filters = $.grep(this.filters, function (e) {
      return e.value == keyword;
    }, true);
    this.filters.push({
      'dimension': 'keyword',
      'value'    : keyword,
      'label'    : keyword,
    });
    this.changed();
  }

  setKeyword(keyword) {
    this.filters = $.grep(this.filters, function (e) {
      return e.dimension === 'keyword';
    }, true);
    keyword && this.filters.push({
      'dimension': 'keyword',
      'value'    : keyword,
      'label'    : keyword,
    });
    this.changed();
  }

  copyFrom(srcFilter, skipActive) {
    if (!skipActive) {
      angular.copy(srcFilter, this);
    } else {
      this.filters = srcFilter.filters.filter(filter =>
        !this.isActive(filter.dimension));
      [
        'id', 'mode', 'listType', 'xaxis', 'charttype',
        'name', 'timeFrom', 'timeTo',
      ].forEach(property => {
        this[property] = srcFilter[property];
      });
    }
  }

  addTimeFilter(date, level, isUTCtime) {
    if (!isUTCtime) date = Filter.toUTCTime(date);
    this.addFilter(
      Filter.timeDimensionForLevel(level),
      Filter.valueForTime(date, level, true),
      Filter.labelForTime(date, level),
    );
  }

  setTimeFilter(date, level, isUTCtime) {
    if (!isUTCtime) date = Filter.toUTCTime(date);
    this.setFilter(
      Filter.timeDimensionForLevel(level),
      Filter.valueForTime(date, level),
      Filter.labelForTime(date, level),
    );
  }

  addFilter(dimension, value, label, predicates) {
//            console.log('addFilter', dimension, value, label );
    if (dimension instanceof Date)
      return this.addTimeFilter(dimension, value, true);
    this.removeFilter(dimension, value);
    if (dimension === 'agent_time@weekday:weekday') {
      label = WEEKDAYS[value];
    }
    this.filters.push({
      'dimension' : dimension,
      'value'     : value,
      'label'     : label,
      'predicates': predicates ? predicates : [],
    });
    this.changed();
  }

  changed() {
    this._changed = true;
  }

  isChanged() {
    return !!this._changed;
  }

  setFilter(dimension, value, label) {
    //console.log('setFilter', dimension, value, label );
    if (dimension instanceof Date)
      return this.setTimeFilter(dimension, value, label);
    this.setOrder(dimension);
    this.filters = [
      {
        'dimension': dimension,
        'value'    : value,
        'label'    : label,
      },
    ];
    this.changed();
  }

  removeFilter(dimension, value) {
    if (typeof(dimension) === 'object') {
      value = dimension.value;
      dimension = dimension.dimension;
    }
//             console.log('removeFilter', dimension, value );
    this.filters = this.filters.filter(filter =>
      filter.dimension !== dimension || filter.value !== value);
    this.changed();
  }

  invertFilter(dimension, value) {
    if (typeof(dimension) === 'object') {
      value = dimension.value;
      dimension = dimension.dimension;
    }
    this.filters.forEach(e => {
      if (e.dimension === dimension && e.value == value) {
        if (!e.predicates) {
          e.predicates = [];
        }
        if (~e.predicates.indexOf('!')) {
          e.predicates.pop('!');
        }
        else e.predicates.push('!');
      }
    });
    this.changed();
  }

  toggleFilter(filter) {
    if (this.hasFilter(filter)) {
      this.removeFilter(filter.dimension, filter.value);
    } else {
      this.addFilter(filter.dimension, filter.value, filter.label);
    }
  }

  viewModeType() {
    let params = this.buildQueryParams();
    let eventtype = '';
    let c = 0;
    if (params && params.dim && params.dim.length) {
      for (let i = 0; i < params.dim.length; i++) {
        if (params.dim[i] === 'agent_eventtype@default:agent_eventtype') {
          eventtype = params.filter[i];
          c++;
          if (c === 2) {
            break;
          }
        }
      }
    }
    return c == 1 ? eventtype : null;
  }

  count(fieldName) {
    if (this.children) {
      return this.children.reduce((prev, child) =>
        prev + child.count(fieldName), this[fieldName]);
    }
    return this[fieldName];
  }

  /**
   * Builds Server query parameters based on current values.
   */
  buildQueryParams() {
    let params = {};
    let drilldown = this.drilldown.slice(0);

    // Include drilldown array
    if (drilldown.length > 0) {
      params['drill'] = drilldown;
    }

    // Include filters
    let dims = [];
    let filters = [];
    this.filters.forEach((e) => {
      dims.push(e.dimension);
      filters.push((e.predicates ? e.predicates.join('') : '') + e.value);
    });

    if (dims.length) {
      params['dim'] = dims;
      params['filter'] = filters;
    }

    if (this.order) {
      params['order'] = this.order;
      params['dir'] = this.orderDir;
    }

    if (this.isAnomaly()) {
      params['threshold'] = this.threshold;
    }

    if (!this.facts_count) {
      if (this.timeFrom) {
        params['time_from'] = Filter.dateToUrl(this.timeFrom);
      }
      if (this.timeTo) {
        params['time_to'] = Filter.dateToUrl(this.timeTo);
      }
    }

    params.page = this.page;
    if (this.facts_count) {
      if (this.facts_count < HARD_LIMIT) {
        params.limit = this.facts_count;
      }
      else {
        params.limit = HARD_LIMIT;
      }
    }
    else {
      params.limit = this.limit;
    }
    if (this.lookup) {
      params.lookup = this.lookup;
    }
    params.id = this.id;
    if (this.hasQuery) {
      params.query = JSON.stringify(this.query);
    }
    return params;
  }

  as_text() {
    return this.filters.reduce(function (previousValue, currentItem) {
      let predicates_value = currentItem.predicates ? currentItem.predicates.reduce(
        function (p, c) {
          return c + p;
        },
        '',
      ) : '';
      let line = currentItem.dimension + '=' + predicates_value + currentItem.value;
      if (currentItem.value != currentItem.label) {
        line += '#' + currentItem.label;
      }
      return previousValue + line + '\n';
    }, '');
  }

  from_text(text) {
    let new_filters = text.split('\n').filter(function (s) {
      return (!!s);
    }).map(function (f) {
      let label = '';
      let value;
      let dim;
      let valpart;
      if (f.indexOf('=') >= 0) {
        dim = f.split('=')[0];
        valpart = f.split('=')[1];
        if (valpart.indexOf('#') >= 0) {
          value = valpart.split('#')[0];
          label = valpart.split('#')[1];
        } else {
          value = valpart;
        }
      } else {
        dim = 'keyword';
        value = '+' + f;
        label = f;
      }
      let predicates_list = ['~', '+', '&', '!'];
      let predicates = [];
      for (let i in predicates_list) {
        let p = predicates_list[i];
        if (value.indexOf(p) >= 0) {
          predicates.push(p);
          value = value.replace(p, '');
        }
      }
      if (!label) label = value;
      return {
        'dimension' : dim,
        'value'     : value,
        'label'     : label,
        'predicates': predicates,
      };
    });
    this.filters = new_filters;
    this.changed();
  }

  getPath(filter) {
    if (this.id === filter.id) {
      return [];
    }
    for (let i = 0; i < this.children.length; ++i) {
      let f = this.children[i];
      let path = f.getPath(filter);
      if (path) {
        return [this, ...path];
      }
    }
  }

  static locLabel(filter) {
    return filter.dimension === 'agent_agent@last_report:last_report' ?
      gettext(filter.label) : filter.label;
  }

  static orderForTimeDimension(dimension) {
    let levels =
      {
        'agent_time@hour:hour'   : 'agent_time.hour',
        'agent_time@y:year'      : 'agent_time.year',
        'agent_time@ym:month'    : 'agent_time.year,agent_time.month',
        'agent_time@ymd:day'     : 'agent_time.year,agent_time.month,agent_time.day',
        'agent_time@ymdh:hour'   : 'agent_time.year,agent_time.month,agent_time.day,agent_time.hour',
        'agent_time@ymdhm:minute': 'agent_time.year,agent_time.month,agent_time.day,agent_time.hour,agent_time.minute',
      };
    return levels[dimension];
  }

  static isTimeDimension(dimension) {
    return dimension &&
      dimension !== 'agent_time@hour:hour' &&
      dimension !== 'agent_time@weekday:weekday' &&
      dimension.indexOf('agent_time') === 0;
  }

  static timeDimensionForLevel(level) {
    let levels =
      [
        'agent_time@y:year',
        'agent_time@ym:month',
        'agent_time@ymd:day',
        'agent_time@ymdh:hour',
        'agent_time@ymdhm:minute',
      ];
    return levels[level - 1];
  }

  static levelsToTime(levels) {
    if (levels.length === 1) {
      let date = new Date();
      date.setFullYear(levels[0]);
      return date;
    }
    levels[1]--;

    function applyToConstructor(constructor, argArray) {
      let args = [null].concat(argArray);
      let factoryFunction = constructor.bind.apply(constructor, args);
      return new factoryFunction();
    }

//             return new Date( Date.UTC.apply( Date, levels ) );
    return applyToConstructor(Date, levels);
  }

  static valueForTime(date, level, isUTCtime) {
    if (!isUTCtime) {
      date = Filter.toUTCTime(date);
    }
    let levels = [
      date.getFullYear(),
      date.getMonth() + 1,
      date.getDate(),
      date.getHours(),
      date.getMinutes(),
    ];
    return levels.splice(0, level).join(PATH_STRING_SEPARATOR); // inverted comma
  }

  static toUTCTime(date, level) {
    return new Date(date.getUTCFullYear(),
      date.getUTCMonth(), date.getUTCDate(),
      date.getUTCHours(), date.getUTCMinutes(),
      date.getUTCSeconds(),
    );
  }

  static labelForTime(date, level) {
    let format = [
      'yyyy', 'MMM-yyyy', 'dd-MMM-yyyy',
      'dd-MMM-yyyy HH:00-HH:59', 'dd-MMM-yyyy HH:mm',
    ][level - 1];
    return Filter.formatDate(date, format);
  }

  static dateToUrl(date) {
    return `${date.getFullYear()}-${('0' + String(date.getMonth() + 1)).slice(-2)}-\
${('0' + date.getDate()).slice(-2)}T${('0' + date.getHours()).slice(-2)}:\
${('0' + date.getMinutes()).slice(-2)}:${('0' + date.getSeconds()).slice(-2)}.\
${('00' + date.getMilliseconds()).slice(-3)}`;
  }

  static urlToDate(text) {
    let date = new Date(Date.parse(text));
    if (isNaN(date.getTime())) {
      // carry about html2pdf
      date = new Date(Date.parse(text + 'Z'));
      if (isNaN(date.getTime())) {
        return null;
      }
      date.setMinutes(date.getMinutes() + date.getTimezoneOffset());
    }
    return date;
  }
}

// GUI state
Filter.prototype.id = 0;
Filter.prototype.mode = DEFAULT_MODE; // explore, chart, report, stat
Filter.prototype.listType = 'table'; // full or brief or table
Filter.prototype.url = '/analytics/report/aggregate/index/';
Filter.prototype.content_type = 'filter';
Filter.prototype.threshold = 10;

// Cube slice
Filter.prototype.drilldown = [];
Filter.prototype.filters = DEFAULT_FILTERS;

Filter.prototype.children = [];

Filter.prototype.dimension = DEFAULT_DRILL;

Filter.prototype.measure = 'record_count';

// Time range
Filter.prototype.timeFrom = null;
Filter.prototype.timeTo = null;

// Paginator
Filter.prototype.page = 0;
Filter.prototype.limit = DEFAULT_FILTER_LIMIT;

Filter.prototype.order = 'record_count';
Filter.prototype.orderDim = null;
Filter.prototype.orderDir = 'desc';

Filter.prototype.shared = false;
Filter.prototype.saved = false;

Filter.prototype.category = 'neutral';
Filter.prototype.cardWidth = 12;
Filter.prototype.cardHeight = 0;



// WEBPACK FOOTER //
// ./src/common/filter.js